type Listener<T> = (state: Partial<T>) => void

export class BaseService<T> {
  protected state: T = null as any

  protected listeners: Set<Listener<T>> = new Set()

  getState(): T {
    return this.state
  }

  updateState(partial: Partial<T>) {
    this.state = { ...this.state, ...partial }
    this.listeners.forEach((fn) => fn(partial))
  }

  resetState() {
    this.state = {} as T
    this.listeners.forEach((fn) => fn(this.state))
  }

  subscribe(fn: Listener<T>) {
    this.listeners.add(fn)
    return () => {
      this.listeners.delete(fn)
    }
  }

  unsubscribe(fn: Listener<T>) {
    this.listeners.delete(fn)
  }
}
